module.exports = __webpack_public_path__ + "img/camera-card.1a71ecd1.png";